import { Key } from '@briebug/ngrx-auto-entity';

export class EquipmentUntrackedClass {
  @Key id: number;
  name: string;
  delta: number;
}
